import { gql } from '@apollo/client';
import CommonFragments from 'features/common/fragments';

export const EXCHANGE_RATE_DELETED = gql`
  subscription exchangeRateDeleted {
    exchangeRateDeleted {
      exchangeRateId
      headers {
        ...messageHeaders
      }
    }
  }
  ${CommonFragments.messageHeaders}
`;

export const EXCHANGE_RATE_IMPORT_SUCCEDED = gql`
  subscription exchangeRateImportSucceeded {
    exchangeRateImportSucceeded
  }
`;


export const EXCHANGE_RATE_IMPORT_STARTED = gql`
  subscription exchangeRateImportStarted {
    exchangeRateImportStarted
  }
`;

export const EXCHANGE_RATE_IMPORT_FAILED = gql`
  subscription exchangeRateImportFailed {
    exchangeRateImportFailed {
      failMessage
    }
  }
`;
